import { render, staticRenderFns } from "./sample-order-message.vue?vue&type=template&id=96d2afe4&"
import script from "./sample-order-message.vue?vue&type=script&lang=js&"
export * from "./sample-order-message.vue?vue&type=script&lang=js&"
import style0 from "./sample-order-message.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports